import style from './style.module.less'

const LazyLoading = () => {
  return (
    <div className={style.wrap}>
      ...
    </div>
  )
}

export default LazyLoading
